var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.TargetGroup.TotalParticipants")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "SummaryReport.TargetGroup.TotalParticipants_Instructions_Stripped"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "SummaryReport.TargetGroup.TotalParticipants_Instructions_Example"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("SummaryReport.TargetGroup.TotalParticipants_Instructions_NB")
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Section")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.TargetGroup.TargetGroup")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("SummaryReport.TargetGroup.TargetGroup_Instructions_Long")
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("SummaryReport.TargetGroup.TargetGroup_Instructions_Long2")
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("SummaryReport.TargetGroup.TargetGroup_Instructions_Long_NB")
        )
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [_vm._v(_vm._s(_vm.$t("SummaryReport.TargetGroup.Name")))])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(_vm._s(_vm.$t("SummaryReport.TargetGroup.IsOrganisation")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(_vm._s(_vm.$t("SummaryReport.TargetGroup.CollectionMethod")))
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t("SummaryReport.TargetGroup.CollectionMethod_Instructions")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(_vm._s(_vm.$t("SummaryReport.TargetGroup.RealizedNumber")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(_vm.$t("SummaryReport.TargetGroup.DistributionHeading"))
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "SummaryReport.TargetGroup.DistributionHeading_Instructions"
              )
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("SummaryReport.TargetGroup.TargetGroup_Instructions_Addl")
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.TargetGroup.ChangeReason")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(_vm.$t("SummaryReport.TargetGroup.ChangeReason_Description"))
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }